var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.2 10.5 11 7.363 12.39 6 18 11.5 12.39 17 11 15.637l3.2-3.137H6v-2z"
})));
export { SvgLongArrowRight as ReactComponent };
export default __webpack_public_path__ + "static/media/longArrowRight.bc4422dd.svg";